import { Middleware } from 'redux';
import * as Sentry from '@sentry/react';

import { hasAssemblyPermission } from '@paragon/login-tools';
import { closeSnackbarsWithMessage, enqueuePermanentError } from '@paragon/notification-tools';

import { hasInvalidRelativeGeometry } from '../../library/relativeGeometry/hasInvalidRelativeGeometry';
import { RootState } from '..';
import { ReduxDispatch } from '../actions/thunkActions';
import { getActiveComponentDesign } from '../selectors/getActiveComponentDesignSelector';

const errorMessage = 'Invalid relative geometry - contact Paragon to fix your component before continuing.';

export const invalidRelativeMiddleware: Middleware<{}, RootState, ReduxDispatch> = (store) => (next) => (action) => {
  const returnValue = next(action);

  const newState = store.getState();

  // Assembly users are not subject to the invalid relative geometry notification. Instead, their trusses are checked
  // on upload for invalid relative geometry.
  if (hasAssemblyPermission(newState)) {
    return returnValue;
  }

  const activeComponentDesign = getActiveComponentDesign(newState);
  const invalidRelativeGeometryExists = activeComponentDesign
    ? hasInvalidRelativeGeometry(activeComponentDesign.component)
    : false;

  const notificationExists = newState.notifications.snackbars.find((snackbar) => snackbar.message === errorMessage);

  if (invalidRelativeGeometryExists && !notificationExists) {
    store.dispatch(enqueuePermanentError(errorMessage));

    Sentry.captureMessage('Component design has invalid relative geometry');
  } else if (!invalidRelativeGeometryExists && notificationExists) {
    store.dispatch(closeSnackbarsWithMessage(errorMessage));
  }

  return returnValue;
};
